import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    navigationBottomBorder: {
        width: '100%',
        height: '4px',
        background: '#d1d1d1',
    },
    navigationBottomInside: {
        height: '4px',
        background: '#1a1a1a',
        borderRadius: '0 16px 16px 0',
    },
}));
